import React, { Component } from "react";
import {
  Container,
  FormControl,
  Nav,
  Navbar,
  Form,
  Button,
} from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "../Pages/Home";
import Contacts from "../Pages/Contacts";
import About from "../Pages/About";
import Gallery from "../Pages/Gallery";
import LogoType from "../assets/Logo.png";

export default class Header extends Component {
  render() {
    return (
      <>
        <Navbar collapseOnSelect expand="md" bg="dark" variant="dark">
          <Container>
            <Navbar.Brand href="">
              <img
                src={LogoType}
                height="50"
                width="70"
                className="d-inline-block aligh-top"
                alt="Logo"
              />UltraPlitka
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link href="/Home"> Home </Nav.Link>
                <Nav.Link href="/Contacts"> Contacts </Nav.Link>
                <Nav.Link href="/About"> About us</Nav.Link>
                <Nav.Link href="/Gallery"> Gallery </Nav.Link>{" "}
              </Nav>
              <Form inline>
                <FormControl
                  type="text"
                  placeholder="Search"
                  className="mr-sm-2"
                />
                <Button variant="outline-info">Search</Button>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <Router>
          <Switch>
          <Route exact path="/" component={Home} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/contacts" component={Contacts} />
            <Route exact path="/about" component={About} />
            <Route exact path="/gallery" component={Gallery} />
          </Switch>
        </Router>
      </>
    );
  }
}
